/**
 * Unified default date range for AI Tuner interfaces:
 * from platform data start through end of tomorrow (UTC for API ISO fields).
 */

/** Earliest inclusive bound for platform data. */
export const PLATFORM_DATA_EARLIEST_ISO = '2025-01-01T00:00:00.000Z';

export interface TrainingDateRange {
  from: string;
  to: string;
}

export interface TrainingDateRangeYmd {
  from: string;
  to: string;
}

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** Start of retained platform data (UTC). */
export function getDefaultTrainingRangeStartIso(): string {
  return PLATFORM_DATA_EARLIEST_ISO;
}

/** End of tomorrow in UTC (23:59:59.999). */
export function getDefaultTrainingRangeEndIso(): string {
  const now = new Date();
  const to = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 23, 59, 59, 999)
  );
  return to.toISOString();
}

/** ISO range for training_period and dataset export APIs. */
export function getDefaultTrainingDateRange(): TrainingDateRange {
  return {
    from: getDefaultTrainingRangeStartIso(),
    to: getDefaultTrainingRangeEndIso(),
  };
}

/** YYYY-MM-DD for platform data start (UTC calendar date). */
export function getPlatformDataEarliestYmd(): string {
  const d = new Date(PLATFORM_DATA_EARLIEST_ISO);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

/** YYYY-MM-DD range for DatePicker filters (local calendar dates). */
export function getDefaultTrainingDateRangeYmd(): TrainingDateRangeYmd {
  const now = new Date();
  const tomorrowLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const toYmd = (d: Date) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  return {
    from: getPlatformDataEarliestYmd(),
    to: toYmd(tomorrowLocal),
  };
}
